module.exports = __webpack_public_path__ + "img/ico-back-hover.add669d7.svg";